import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {IRedeem} from '../types/redeemBanner';
import {buttonProxy} from './button.proxy';

export function redeemProxy(component: any): IRedeem {
    const componentType = component?.fields?.componentType;
    const RedeemPage = component?.fields?.entries?.[0]?.fields;
    return {
        componentType,
        redeem: {
            title: RedeemPage?.title,
            subtitle: RedeemPage?.subtitle,
            description: RedeemPage?.description,
            order: RedeemPage?.Order,
            inputPlaceholder: RedeemPage?.inputPlaceholder,
            errorText: RedeemPage?.errorText?.[0]?.fields?.value,
            supportText: RedeemPage?.supportText,
            image: getImage(RedeemPage?.backgroundImage),
            ctaButton: buttonProxy(RedeemPage?.ctaButton?.fields)
        }
    };
}
